import { render, staticRenderFns } from "./AppointmentCompleteWrapper.vue?vue&type=template&id=35094d88"
import script from "./AppointmentCompleteWrapper.vue?vue&type=script&lang=js"
export * from "./AppointmentCompleteWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35094d88')) {
      api.createRecord('35094d88', component.options)
    } else {
      api.reload('35094d88', component.options)
    }
    module.hot.accept("./AppointmentCompleteWrapper.vue?vue&type=template&id=35094d88", function () {
      api.rerender('35094d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/appointmentManagement/AppointmentCompleteWrapper.vue"
export default component.exports